<template>
    <v-container fluid class="pa-0">
      <v-row dense>
        <v-col cols="12" class="pa-0 ma-0">
            <verificaqr/>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  
  <script>
  
  
  import verificaqr from '@/components/VerificaQR/verificaqr.vue';
  export default {
    name: "verificaqrView",
    components: {
        verificaqr,    
    },
    data: () => ({}),
    computed: {},
    methods: {
    },
  };
  </script>
  